var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3348 0.0668945V31.1132C34.5064 31.1649 34.7353 31.1132 34.8498 31.1132H39.485C39.7711 31.1132 40 30.9062 40 30.6475V0.584332C40 0.27387 39.7711 0.118638 39.485 0.118638H34.2775L34.3348 0.0668945ZM28.6123 2.65408L11.9599 10.2604C11.6738 10.3639 11.216 10.4156 10.8727 10.4156H0.515022C0.171674 10.4156 0 10.6226 0 10.8813V20.247C0 20.5574 0.228898 20.7127 0.515022 20.7127H5.72246L11.6166 34.787C12.2461 36.0806 14.1345 36.6497 15.5651 36.0806C16.9957 35.5114 17.6252 33.8038 16.9957 32.5102L12.7039 23.2998C12.8755 22.5754 13.4478 22.1615 14.3062 22.1615V22.0063L28.6123 28.4742V2.60234V2.65408Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityIcon);
export default __webpack_public_path__ + "static/media/communityIcon.41451e995c4c963781baee3c2f406c47.svg";
export { ForwardRef as ReactComponent };